import React from 'react';
import { Play, ExternalLink, Youtube } from 'lucide-react';
import { motion } from 'framer-motion';
import { recipes } from '../data/recipes';
// Featured videos — a curated selection from the channel
const featuredVideos = [{
  videoId: '-mRkKn8swdk',
  title: 'Pav Bhaji Pizza Buns',
  category: 'Fusion'
}, {
  videoId: 'zAU90Ap1z04',
  title: 'TikTok Tortilla Wrap Hack — 4 Types',
  category: 'Fusion'
}, {
  videoId: 'XadTbzn_5PE',
  title: 'Pizza Panipuri — Cheese Burst',
  category: 'Street Food'
}, {
  videoId: 'QQUEneifrfE',
  title: 'Tandoori Dhokla in a Pan',
  category: 'Fusion'
}, {
  videoId: 'zSwZA5zHlOM',
  title: 'Quick Kadhai Paneer — Dhaba Style',
  category: 'Curries'
}, {
  videoId: '8GTrp3e-6Eg',
  title: 'Paneer Tikka — Restaurant Style',
  category: 'Appetizer'
}, {
  videoId: 'NW6vN9N8Dlw',
  title: '3-Ingredient Caramel Makhana',
  category: 'Vrat'
}, {
  videoId: 'g3rggfrdKSo',
  title: 'No-Dough Paneer Samosa',
  category: 'Fusion'
}, {
  videoId: 'FKsX85LjHUk',
  title: 'Kashmiri Pulao',
  category: 'Rice'
}];
const thumb = (id: string) => `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
const yt = (id: string) => `https://www.youtube.com/watch?v=${id}`;
export function YouTubeSection() {
  return <section id="videos" className="py-20 px-4 bg-stone-900 text-white" data-id="element-336">
      <div className="max-w-7xl mx-auto" data-id="element-337">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-12" data-id="element-338">
          <div data-id="element-339">
            <div className="flex items-center gap-3 mb-3" data-id="element-340">
              <div className="bg-red-600 p-2 rounded-lg" data-id="element-341">
                <Youtube size={24} data-id="element-342" />
              </div>
              <span className="text-red-400 font-bold uppercase tracking-widest text-sm" data-id="element-343">
                BeVegToday Channel
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold" style={{
            fontFamily: 'Poppins, sans-serif'
          }} data-id="element-344">
              Watch & Cook 📺
            </h2>
            <p className="text-stone-400 mt-2 max-w-lg" data-id="element-345">
              Step-by-step video tutorials for every recipe — straight from the
              BeVegToday kitchen.
            </p>
          </div>
          <a href="https://www.youtube.com/c/BeVegToday" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-full font-bold transition-colors shadow-lg shadow-red-600/30 whitespace-nowrap" data-id="element-346">
            <Youtube size={20} data-id="element-347" /> Subscribe to Channel
          </a>
        </div>

        {/* Channel Banner */}
        <div className="bg-gradient-to-r from-green-800 to-green-600 rounded-2xl p-6 md:p-8 mb-10 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-348">
          <div className="flex items-center gap-5" data-id="element-349">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-3xl shadow-lg" data-id="element-350">
              🌿
            </div>
            <div data-id="element-351">
              <h3 className="text-2xl font-bold" style={{
              fontFamily: 'Poppins, sans-serif'
            }} data-id="element-352">
                BeVegToday
              </h3>
              <p className="text-green-200 text-sm" data-id="element-353">
                Your daily dose of vegetarian inspiration
              </p>
              <p className="text-green-300 text-xs mt-1" data-id="element-354">
                {recipes.length}+ recipes · Indian & Fusion · 100% Vegetarian
              </p>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-355">
            <a href="https://www.youtube.com/c/BeVegToday" target="_blank" rel="noopener noreferrer" className="bg-white text-green-800 px-6 py-2.5 rounded-full font-bold hover:bg-green-50 transition-colors" data-id="element-356">
              View All Videos
            </a>
          </div>
        </div>

        {/* Video Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-357">
          {featuredVideos.map((video, index) => <motion.a key={video.videoId} href={yt(video.videoId)} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="group bg-stone-800 rounded-xl overflow-hidden hover:ring-2 hover:ring-red-500 transition-all" data-id="element-358">
              <div className="relative aspect-video bg-stone-700" data-id="element-359">
                <img src={thumb(video.videoId)} alt={video.title} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity" onError={e => {
              ;
              (e.target as HTMLImageElement).src = `https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg`;
            }} data-id="element-360" />
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-361">
                  <div className="bg-red-600/90 p-3.5 rounded-full transform scale-90 group-hover:scale-110 transition-transform shadow-xl" data-id="element-362">
                    <Play size={22} fill="white" data-id="element-363" />
                  </div>
                </div>
                <div className="absolute top-2 left-2" data-id="element-364">
                  <span className="bg-black/60 backdrop-blur-sm text-white text-xs font-bold px-2 py-1 rounded" data-id="element-365">
                    {video.category}
                  </span>
                </div>
              </div>
              <div className="p-4" data-id="element-366">
                <h3 className="font-bold text-white line-clamp-2 group-hover:text-red-400 transition-colors leading-snug" style={{
              fontFamily: 'Poppins, sans-serif'
            }} data-id="element-367">
                  {video.title}
                </h3>
                <div className="flex items-center gap-2 mt-2 text-stone-400 text-xs" data-id="element-368">
                  <Youtube size={12} className="text-red-500" data-id="element-369" />
                  <span data-id="element-370">BeVegToday</span>
                  <span data-id="element-371">·</span>
                  <span className="flex items-center gap-1 text-red-400 font-semibold" data-id="element-372">
                    Watch Now <ExternalLink size={10} data-id="element-373" />
                  </span>
                </div>
              </div>
            </motion.a>)}
        </div>

        <div className="text-center mt-10" data-id="element-374">
          <a href="https://www.youtube.com/c/BeVegToday" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border-2 border-stone-600 hover:border-red-500 text-stone-300 hover:text-red-400 px-8 py-3 rounded-full font-bold transition-all" data-id="element-375">
            <Youtube size={18} data-id="element-376" /> View All Videos on YouTube
          </a>
        </div>
      </div>
    </section>;
}